import { catchError, map, Observable, of, tap } from 'rxjs';
import { ComponentDataSourceService } from '../../component-data-source.service';
import { GoalDTO } from '../../../../dto/goal/goal.dto';
import { Goal } from '../../../../models/goal/Goal.model';
import { LoadDataParams } from '../../../../interfaces/DataSource/DataSourceParams.interface';
import { FunctionRegistryService } from '../../../function-registry/function-registry.service';
import { environment } from '../../../../environment/environment';

export function goals(componentDataSourceService: ComponentDataSourceService, functionRegistryService: FunctionRegistryService) {
  return {
    name: 'Goals',
    description: 'Lists all goals',
    execute: (params?: LoadDataParams) => {
      
      return componentDataSourceService.http.get<any>(
        `${environment.apiUrl}/events/goals`,
        params?.queryParams ? { params: params.queryParams } : {}
      ).pipe(
        tap(result => {
          if (result?.items) {
          }
        }),
        catchError(error => {
          console.error('[goals] Error fetching goals:', error);
          if (error.error) {
            console.error('[goals] Error response body:', error.error);
          }
          return of({ items: [], totalCount: 0 });
        }),
        map(result => {
          if (result && result.items) {
            try {
              const goals = result.items.map((goal: any) => {
                
                const goalDTO: GoalDTO = {
                  goal_id: goal.goal_id,
                  base_goal_id: goal.base_goal_id,
                  name: goal.name,
                  descriptions: goal.descriptions,
                  version_start_date: goal.version_start_date ? new Date(goal.version_start_date) : new Date(),
                  version_end_date: goal.version_end_date ? new Date(goal.version_end_date) : undefined,
                  visibility: goal.visibility,
                  subtypes: goal.subtypes || []
                };

                try {
                  const convertedGoal = Goal.fromDTO(goalDTO);
                  
                  const result = {
                    ...convertedGoal,
                    descriptions: convertedGoal.descriptions?.['da']?.translation_text || ''
                  };
                  return result;
                } catch (error) {
                  console.error('[goals] Error converting DTO to model:', error);
                  throw error;
                }
              });

              return {
                items: goals,
                totalCount: result.totalCount,
                pageSize: result.pageSize,
                pageIndex: result.pageIndex
              };
            } catch (error) {
              console.error('[goals] Error in mapping process:', error);
              return { items: [], totalCount: 0 };
            }
          } else {
            console.warn('[goals] No items found in response');
            throw new Error('No goals found');
          }
        })
      );
    },
    settings: {
      columns: [
        { key: 'name', header: 'Navn', type: 'text' },
        { key: 'version_start_date', header: 'Start dato', type: 'date' },
        { key: 'version_end_date', header: 'Slutdato', type: 'date' },
        { key: 'descriptions', header: 'Beskrivelse', type: 'text', transform: (value: string) => value?.substring(0, 40) + '...' },
        {
          key: 'actions',
          header: '',
          type: 'button',
          buttonText: 'Rediger',
          buttonColor: 'primary',
          variant: 'raised',
          action: (row: any) => {
            functionRegistryService.executeFunction('openModal', 'goal-modal');
          }
        }
      ],
      pageable: true,
      sortable: true,
      rowHover: true,
      defaultSortColumn: 'version_start_date',
      defaultSortDirection: 'asc'
    }
  }
} 